<template>
    <div class="accountformMobile">
      <img src="../../assets/image/nominatorBg.png" class="accountBack">
      <div class="contentBack">
          <el-form :model="form" ref="form" :rules="formRules" label-position="left">
              <div class="row">
                  <div class="rowItem">
                      <el-form-item label="Your Name" prop="user_name">
                          <el-input  v-model="form.user_name"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                <div class="rowItem" >
                      <el-form-item label="Name of Your School" prop="school">
                          <el-input  v-model="form.school"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                <div class="rowItem" >
                      <el-form-item label="Your Email Address" prop="user_email">
                          <el-input  v-model="form.user_email"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                <div class="rowItem" >
                      <el-form-item label="Your Phone Number" prop="user_phone">
                          <el-input  v-model="form.user_phone"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                  <el-form-item label="Where do you learn about EAE" prop="where">
                      <div style="display: inline-block;width:100%">
                          <el-checkbox-group v-model="form.where">
                              <div ><el-checkbox label="Website Search" /></div>
                              <div ><el-checkbox label="Social Media" /></div>
                              <div ><el-checkbox label="Friend's Recommendation" /></div>
                              <div ><el-checkbox label="Application Counselor" /></div>
                              <div ><el-checkbox label="Others"/></div>
                          </el-checkbox-group>
                      </div>
                  </el-form-item>
              </div>
              
              <div class="row">
                  <el-form-item label="Which category do you plan to apply?" prop="selectCategory">
                      <div style="display: inline-block;width:100%">
                        <el-select
                          v-model="form.selectCategory"
                          placeholder="Select category"
                          @change="doSearch"
                          style="width: 300px"
                        >
                          <el-option
                            v-for="(category, index) in categories"
                            :key="index"
                            :label="category.name"
                            :value="category.name"
                          ></el-option>
                        </el-select>
                      </div>
                  </el-form-item>
              </div>

            
              <div class="row">
                  <div class="rowItem">
                      <el-form-item label="Name of Your Teacher" prop="contact_name">
                          <el-input  v-model="form.contact_name"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                <div class="rowItem" >
                      <el-form-item label="Email of Your Teacher" prop="contact_email">
                          <el-input  v-model="form.contact_email"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <!-- <div class="row">
                  <div class="rowItem">
                      <el-form-item label="Registrant’s Mobile" prop="regMobile">
                          <el-input  v-model="form.regMobile"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                <div class="rowItem" >
                      <el-form-item label="Registrant’s IM (Please also specify the IM platform)" prop="regWechat">
                          <el-input  v-model="form.regWechat"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                  <div class="rowItem">
                      <el-form-item label="Registrant’s Email Address" prop="regEmail">
                          <el-input  v-model="form.regEmail"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                <div class="rowItem" >
                      <el-form-item label="Registrant’s Title" prop="regTitle">
                          <el-input  v-model="form.regTitle"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                  <div class="rowItem">
                      <el-form-item label="Are you also the program adviser?" prop="adviserStatus">
                          <el-input  v-model="form.adviserStatus"></el-input>
                      </el-form-item>
                  </div>
              </div> -->
              <!-- <div class="row" style="font-size: 16px;color: #333333;font-weight: bold;">Program Adviser</div>
              <div class="row" style="color:#666666">If you are not the adviser，please provide the adviser’s information in the following form.</div>
              <div class="row">
                  <div class="rowItem">
                      <el-form-item label="Name">
                          <el-input  v-model="form.adviserName"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                <div class="rowItem" >
                      <el-form-item label="Title">
                          <el-input  v-model="form.adviserTitle"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                  <div class="rowItem">
                      <el-form-item label="Email">
                          <el-input  v-model="form.adviserEmail"></el-input>
                      </el-form-item>
                  </div>
              </div> -->
              <div class="row" style="margin-bottom:50px">
                  <span class="submit" @click="submit">Submit</span>
              </div>
          </el-form>
      </div>
    </div>
  </template>

<script>
import { saveNominatorForm,getTypes } from '../../api/eae'
import '../../assets/common/common.css'

export default {
  data () {
    return {
      categories:[],
      form: {
        user_name: '',
        school: '',
        user_email: [],
        user_phone: [],
        where: [],
        selectCategory: '',
        contact_name: '',
        contact_email: '',
      },
      formRules: {
        user_name: [
          { required: true, message: 'Please input', trigger: 'blur' }
        ],
        school: [
          { required: true, message: 'Please input', trigger: 'blur' }
        ],
        user_email: [
          { required: true, message: 'Please input', trigger: 'blur' }
        ],
        where: [
          { required: true, message: 'Please select', trigger: 'change' }
        ],
        contact_name: [
          { required: true, message: 'Please input', trigger: 'blur' }
        ],
        contact_email: [
          { required: true, message: 'Please input', trigger: 'blur' }
        ],
        selectCategory: [
          { required: true, message: 'Please select', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.requestAllCategories();
  },
  methods: {
    submit () {
      this.$refs.form.validate((val) => {
        if (val) {
          saveNominatorForm(this.form).then(res => {
            if (res.data) {
              this.$confirm('Added Successfully', 'Tips', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'success',
                customClass: 'mobileConfirm'
              })
            }
          })
        } else {
          this.$confirm('Please fill in the required information', 'Tips', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
            customClass: 'mobileConfirm'
          })
        }
      })
    },
    requestAllCategories() {
      getTypes().then((res) => {
        let result = [
            ...res.data.data.filter((item) => item.name !== "Others"),
            ...res.data.data.filter((item) => item.name === "Others"),
          ];
        this.categories = result
      });
    },
  }
}
</script>

  <style scoped lang="scss">
  .accountformMobile{
      width: 100%;
      font-family: "DDINAlternateRegular";
      overflow: hidden;
      box-sizing: border-box;
      overflow-y: scroll;
      background: url(../../assets/image/accountBack.png);
          background-position: 0 0;
          background-size: 100% 100%;
      .accountBack{
          width: 100%;
          display: block;
      }
      .contentBack{
        width: 100%;
        box-sizing: border-box;
      }
      .row{
          width: 90%;
          margin: 0 auto;
          justify-content: space-between;
          margin-bottom: 20px;
          display: flex;
          .rowItem{
            width: 100%;
          }
      }
      .el-checkbox-group{
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
      }
      .el-radio-group{
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
      }
      .submit{
          padding: 10px 70px;
          background: #F55443;
          color: #fff;
          cursor: pointer;
      }
  }
  </style>
  <style lang="scss">
  .accountform{
      .el-form-item__label{
          font-size: 16px;
          color: #333333;
          font-weight: bold;
      }
      .el-checkbox__label{
          font-size: 16px;
          color: #666666;
      }
      .el-radio__label{
          font-size: 16px;
          color: #666666;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
          background-color: #F55443;
          border-color: #F55443;
      }
      .el-checkbox__input.is-checked+.el-checkbox__label{
          color: #F55443;
      }
      .el-radio__input.is-checked .el-radio__inner{
          background-color: #F55443;
          border-color: #F55443;
      }
      .el-radio__input.is-checked+.el-radio__label{
          color: #F55443;
      }
  }
  .mobileConfirm{
    width: 80%;
    .el-message-box__container{
        display: flex;
        .el-message-box__status{
            position: relative;
            flex-shrink: 0;
            transform:none
        }
        .el-message-box__message{
            padding-left: 10px;
        }
    }
  }
  </style>
